export default "__VITE_ASSET__D_V8qfa8__"